import moment from "moment";

export function handleDob(dob, setDOB, setMessage, setErrorAlert, setSeverity, onClear) {
  const today = new Date();
  if (today < new Date(dob)) {
    setMessage("DOB can not be in the future");
    setSeverity("warning");
    setErrorAlert(true);
    setTimeout(() => {
      setErrorAlert(false);
      setMessage("");
      setSeverity("");
      if (typeof onClear === "function") onClear();
      else if (document.getElementById("dob_input")) document.getElementById("dob_input").value = "";
    }, 1500);
  } else if (moment().diff(moment(dob), "years") < 16) {
    setMessage("You must be at least 16 years old");
    setSeverity("warning");
    setErrorAlert(true);
    setTimeout(() => {
      setErrorAlert(false);
      setMessage("");
      setSeverity("");
      if (typeof onClear === "function") onClear();
      else if (document.getElementById("dob_input")) document.getElementById("dob_input").value = "";
    }, 1500);
  } else {
    setDOB(dob);
  }
}

export function handleUK(uk, setEU, setShowBox) {
  if (uk === "Yes") {
    setEU(true);
    setShowBox(false);
  } else if (uk === "No") {
    setEU(false);
    setShowBox(true);
  } else {
    setEU(null);
    setShowBox(false);
  }
}

export function handleExpireShare(date, setShareExpire) {
  const today = new Date();
  const formats = ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY"];
  const formatedDate = moment(date, formats, true);
  const normalizedDate = formatedDate.isValid()
    ? formatedDate.format("YYYY-MM-DD").toString()
    : null;
  if (today > new Date(date) || !normalizedDate) {
    const el = document.getElementById("share");
    if (el) {
      el.style.display = "flex";
      setTimeout(() => {
        el.style.display = "none";
        const input = document.getElementById("share_code");
        if (input) input.value = "";
      }, 1500);
    }
  } else {
    setShareExpire(normalizedDate);
  }
}

export function handleEmployment(status, _current, setEmploymentStatus) {
  setEmploymentStatus(status);
}

export function handleMedical(med, _current, setMedical, setMedBox) {
  setMedical(med);
  setMedBox(med !== "no");
}

export function handleConvictions(conv, _current, setConviction, setConvBox) {
  setConviction(conv);
  setConvBox(conv === "yes");
}

export function handleSmoke(conf, _current, setSmoke) {
  setSmoke(conf);
}
